import React, { useEffect } from 'react';
import { Box, BoxProps, Button, Flex, Heading, Image, Link, Text, Wrap, WrapItem } from '@chakra-ui/react';
import { Food, Restaurant } from '../../../type';
import LocationIcon from '../atom/LocationIcon';
import CallIcon from '../atom/CallIcon';
import UtensilsIcon from '../atom/UtensilsIcon';
import ShareIcon from '../atom/ShareIcon';
import { gaRestaurantSelect, gaRestaurantShare } from '../../../utils/gaUtils';

type RestaurantCardProps = {
  food: Food;
  restaurant: Restaurant;
};

const RestaurantCard: React.FC<RestaurantCardProps & BoxProps> = (props: RestaurantCardProps & BoxProps) => {
  const food = props.food;
  const restaurant = props.restaurant;
  const uniqueId = (Math.random() + 1).toString(36).substring(5);
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  useEffect(() => {
    if (window.Kakao) {
      const image = restaurant.image_url ? restaurant.image_url : '/noimage.jpg';
      if (!window.Kakao.isInitialized()) {
        window.Kakao.init(process.env.REACT_APP_KAKAO_KEY);
      }
      window.Kakao.Link.createDefaultButton({
        container: `#kakao-link-btn-${uniqueId}`,
        objectType: 'location',
        address: restaurant.address,
        addressTitle: `${restaurant.name}`,
        content: {
          title: `우리 ${restaurant.name}에서 ${food.name} 먹을까요?`,
          description: '#숨쉴때 #메뉴추천',
          imageUrl: image,
          link: {
            mobileWebUrl: `${baseUrl}`,
            webUrl: `${baseUrl}`,
          },
        },
        buttons: [
          {
            title: '다른 음식점 보기',
            link: {
              mobileWebUrl: `${baseUrl}/restaurant/${food.name}`,
              webUrl: `${baseUrl}/restaurant/${food.name}`,
            },
          },
        ],
      });
    }
  }, []);
  const selectRestaurant = () => {
    gaRestaurantSelect(restaurant.name);
  };
  const shareRestaurant = () => {
    gaRestaurantShare(restaurant.name);
  };
  return (
    <Box
      maxW='sm'
      my={6}
      p={6}
      borderRadius='lg'
      boxShadow='md'
      bg='grayBackground'
      overflow='hidden'
      {...(props as BoxProps)}
    >
      <Flex justify='space-between'>
        <Link
          onClick={selectRestaurant}
          isExternal
          textDecoration='none'
          _hover={{
            textDecoration: 'none',
          }}
          mr={2}
          maxW='60%'
        >
          <Flex direction={'column'} justify={'space-between'} cursor='pointer'>
            <Box my={2}>
              <Text>{restaurant.type}</Text>
              <Heading size='lg' isTruncated>
                {restaurant.name}
              </Heading>
            </Box>
            <Flex direction={'column'}>
              <Box my={2}>
                <Wrap space={0}>
                  <WrapItem>
                    <LocationIcon mt={1} />
                  </WrapItem>
                  <WrapItem>
                    <Text>{restaurant.near}에서</Text>
                  </WrapItem>
                  <WrapItem>
                    <Text>{restaurant.distance}m</Text>
                  </WrapItem>
                </Wrap>
                <Wrap space={0}>
                  <WrapItem>
                    <CallIcon mt={1} />
                  </WrapItem>
                  <WrapItem>
                    <Text>{restaurant.contact ? restaurant.contact : '연락처 정보 없음'}</Text>
                  </WrapItem>
                </Wrap>
              </Box>
              <Box my={2}>
                <Flex direction='column'>
                  <Flex>
                    <UtensilsIcon mt={1} mr={1} />
                    <Heading size='sm'>대표 메뉴</Heading>
                  </Flex>
                  <Text ml={5}>{restaurant.foods[0].name}</Text>
                </Flex>
              </Box>
            </Flex>
          </Flex>
        </Link>
        <Flex direction={'column'} align={'end'} justify={'space-between'}>
          <Image
            src={restaurant.image_url ? restaurant.image_url : '/noimage.jpg'}
            fallbackSrc='/noimage.jpg'
            borderRadius='lg'
            width='25vw'
            height='25vw'
            maxW={28}
            maxH={28}
            objectFit='cover'
            objectPosition='center'
          />
          <Button
            p={0}
            id={`kakao-link-btn-${uniqueId}`}
            ml={'auto'}
            bg='primary'
            borderRadius='full'
            cursor='pointer'
            aria-label='공유하기'
            onClick={shareRestaurant}
          >
            <ShareIcon color='white' />
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
  // TODO: Share Restaurant to others.
};

export default RestaurantCard;
